export default __webpack_public_path__ + "static/Artificial_Light_Indoor_1600kbps-7fe2c5c0322598de648b33e6b3dd9745.avif";